"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheDesignManifesto() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section data-section-id="123456" id="mastering-the-craft" className="bg-background text-foreground py-[12vw] px-[8vw] overflow-hidden">
      <div className="mx-auto max-w-[1400px] flex flex-col md:flex-row">
        {}
        <div className="hidden md:block md:w-[40%] shrink-0 bg-[url('https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=1000&auto=format&fit=crop')] bg-cover bg-center grayscale contrast-125" aria-hidden="true">
          {}
        </div>

        {}
        <div ref={ref} className={`w-full md:w-[60%] flex flex-col gap-12 md:gap-16 transition-all duration-1000 ease-out md:pl-20 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-sans font-bold text-4xl md:text-5xl lg:text-6xl xl:text-7xl leading-[1.1] tracking-tighter text-primary">
            Mastering the Craft.
          </h2>

          <div className="flex flex-col gap-8 font-sans text-lg md:text-xl leading-[1.8] text-primary max-w-2xl">
            <p>
              At Quinn Studio, precision is our baseline. We harness advanced additive manufacturing 
              and laser technologies to transform digital blueprints into high-fidelity physical 
              components. Every micron is accounted for in our pursuit of industrial perfection.
            </p>
            <p>
              Our facility operates at the intersection of engineering and design. By integrating 
              high-speed 3D printing with precision laser engraving, we provide a vertically 
              integrated solution for prototyping and final production that meets the most rigorous tolerances.
            </p>
            <p>From aerospace-grade filaments to bespoke FDM prints or the perfect marketing tchotchke, our work is defined by the mechanical integrity of our processes. We do not just build objects; we engineer and craft solutions for your friends, family, or business.</p>
          </div>

          {}
          <div className="pt-8">
            <svg viewBox="0 0 300 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-48 md:w-64 h-auto text-primary opacity-40" aria-label="Manufacturing Quality Seal">
              <path d="M20 50 L280 50 M50 20 L50 80 M250 20 L250 80" stroke="currentColor" strokeWidth="1" strokeLinecap="square" strokeLinejoin="miter" className="path-draw" style={{
              strokeDasharray: 1000,
              strokeDashoffset: isVisible ? 0 : 1000,
              transition: "stroke-dashoffset 2s ease-in-out 0.5s"
            }} />
            </svg>
            <span className="block mt-4 text-xs tracking-[0.2em] uppercase text-primary font-mono font-medium">System Tolerance: 0.03mm Accuracy</span>
          </div>
        </div>
      </div>
    </section>;
}